export const checkClientType = (clientType?: string) => {
  switch (clientType) {
    case 'view':
      return false;
    case 'regular':
      return true;
    default:
      return true;
  }
}

export const canEditField = (fieldName: string, clientType?: string): boolean => {  
  // Si no hay clientType o es 'regular', puede editar todo
  if (!clientType || clientType === 'regular') {
    return true;
  }
  
  // Para clientes 'view', solo pueden editar purchaseOrder
  if (clientType === 'view') {
    return ['purchaseOrder'].includes(fieldName);
  }
  
  return true;
}